<template>
  <div>
    <div class="navbar">
      <!-- <hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      /> -->
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
      <div class="right-menu">
        <template>
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
        </template>
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <!-- <i class="el-icon-user-solid"></i> -->
            <!-- <i class="el-icon-caret-bottom" /> -->
            {{ hellowHandle }}{{ username }}
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="editLoginPwd">
              <span style="display: block">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logoutHandle">
              <span style="display: block">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-dialog title="修改密码" :visible.sync="pwdOnoff" :modal-append-to-body="false">
      <el-form :model="pwdForm" label-width="100px" ref="pwdFormRef" :rules="rules">
        <el-form-item label="原密码：" prop="oldPwd">
          <el-input v-model.trim="pwdForm.oldPwd" maxlength="32" placeholder="请输入原密码" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPwd">
          <el-input v-model.trim="pwdForm.newPwd" maxlength="32" placeholder="请输入新密码" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPwd">
          <el-input v-model.trim="pwdForm.confirmPwd" maxlength="32" placeholder="请再次输入新密码" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdOnoff = false">取消</el-button>
        <el-button type="success" @click="submitPwd">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
import { encryptRSA } from "../../utils";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
  },
  data() {
    const validatePwd = (rule, value, callback) => {
      if (value) {
        if (value.length < 8 || value.length > 32) {
          callback(new Error("请输入8-32位"));
        } else {
          const re = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,32}$/;
          if (re.test(value)) {
            callback();
          } else {
            callback(new Error("密码需包括大小写字母、数字和特殊字符"));
          }
        }
      } else {
        callback();
      }
    };
    return {
      username: localStorage.getItem("user-name"),
      pwdOnoff: false,
      pwdForm: {},
      rules: {
        oldPwd: [{ required: true, message: "必填", trigger: "blur" }],
        newPwd: [
          { required: true, message: "必填", trigger: "blur" },
          { trigger: "blur", validator: validatePwd },
        ],
        confirmPwd: [
          { required: true, message: "必填", trigger: "blur" },
          { trigger: "blur", validator: validatePwd },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["sidebar"]),
    hellowHandle() {
      var time = new Date().getHours();
      if (time > 0 && time <= 5) {
        return "凌晨好，";
      } else if (time > 5 && time <= 8) {
        return "早上好，";
      } else if (time > 8 && time <= 12) {
        return "上午好，";
      } else if (time > 12 && time <= 13) {
        return "中午好，";
      } else if (time > 13 && time <= 19) {
        return "下午好，";
      } else if (time > 19 && time <= 24) {
        return "晚上好，";
      } else {
        return "您好，";
      }
    },
  },

  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logoutHandle() {
      this.$confirm("确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.logout();
      });
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login`);
    },
    editLoginPwd() {
      this.pwdOnoff = true;
    },
    submitPwd() {
      this.$refs.pwdFormRef.validate((valid) => {
        if (valid) {
          if (this.pwdForm.newPwd != this.pwdForm.confirmPwd) {
            this.$message("新密码与确认密码不一致");
            return;
          }
          const arg = {
            id: localStorage.getItem("user-id"),
            oldPwd: encryptRSA(this.pwdForm.oldPwd),
            newPwd: encryptRSA(this.pwdForm.newPwd),
            confirmPwd: encryptRSA(this.pwdForm.confirmPwd),
          };
          // const arg = Object.assign(this.pwdForm, {id: localStorage.getItem('user-id')})
          this.request({
            url: "/admin/user/modify",
            method: "post",
            params: arg,
          }).then((res) => {
            this.$message({
              message: "设置成功，请重新登录",
              type: "success",
            });
            this.logout();
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/ui.scss";

.navbar {
  overflow: hidden;
  position: relative;
  height: $navbarH !important;
  display: flex;
  align-items: center;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    position: absolute;
    right: 0;
    line-height: inherit;
    height: auto;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      vertical-align: text-bottom;
      color: var(--siderBar);

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue